import * as React from 'react'

import { IconProps } from '@zet/design-system'
import Svg, { Path } from 'react-native-svg'

const ShareFilled = ({ color = '#000', ...props }: IconProps) => (
  <Svg
    width={18}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M3.33 11.7a2.9 2.9 0 0 0 1.69-.53l6.67 3.23c-.04.2-.06.4-.06.61 0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3c-.8 0-1.52.32-2.05.82L6.14 9.71c.12-.32.19-.66.19-1.02 0-.26-.04-.51-.1-.75l6.16-2.98c.55.63 1.35 1.04 2.25 1.04 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .11.02.21.03.31l-6.41 3.1c-.52-.44-1.19-.72-1.93-.72-1.66 0-3 1.34-3 3s1.34 3 3 3v.01Z"
      fill={color}
    />
  </Svg>
)

export default ShareFilled
